import * as React from 'react';

import { ListingSkeleton } from '../../../common/components/OfferCard/components/OfferCardSkeleton';
import { IDailyRentOfferForMobileSite } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { EmptyListingContainer } from '../../containers/EmptyListingContainer';
import { ListingMobileOffersContent } from '../ListingMobileOffersContent';

interface IListingMobileContentProps {
  isLoading: boolean;
  offers: IDailyRentOfferForMobileSite[];
  isListingModalOpen: boolean;
  onEmptyListingShow(): void;
  onBreadcrumbClick(): void;
}

export const ListingMobileContent = ({
  isLoading,
  offers,
  isListingModalOpen,
  onEmptyListingShow,
  onBreadcrumbClick,
}: IListingMobileContentProps) => {
  if (isLoading) {
    return <ListingSkeleton count={3} />;
  }

  if (!offers.length && isListingModalOpen) {
    return <EmptyListingContainer onShow={onEmptyListingShow} />;
  }

  if (!offers.length) {
    return null;
  }

  return <ListingMobileOffersContent offers={offers} onBreadcrumbClick={onBreadcrumbClick} />;
};

ListingMobileContent.displayName = 'ListingMobileContent';
